import * as React from 'react';
import { UitkCard, UitkCardMedia } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType } from 'uitk-react-images';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { AlternateDestination } from 'src/common/models';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { AlternateDestinationImage } from './alternate-destination-image';
import { AlternateDestinationLink } from './alternate-destination-link';

export interface AlternateDestinationCardProps {
  destination?: AlternateDestination;
  position: number;
}

export class AlternateDestinationCardLarge extends React.Component<AlternateDestinationCardProps> {
  public render() {
    const { destination, position } = this.props;

    if (!destination) {
      return null;
    }

    const isAirport = destination.type === 'AIRPORT';

    return (
      <UitkCard data-stid="alternate-destination-card-large">
        <UitkCardMedia>
          <UitkFigure className="all-image-fit-cover" ratio={UitkFigureAspectRatioType.R21_9}>
            <AlternateDestinationImage image={destination.image} />
            <UitkScrim type={UitkScrimType.BOTTOM} className="white-space-normal">
              <h4 className="uitk-type-400">
                {isAirport && <UitkIcon name="lob_flights" size={UitkIconSize.EXTRA_SMALL} shadow={true} className="all-r-margin-one" />}
                {destination.title}
              </h4>
              <span>{destination.subTitle}</span>
            </UitkScrim>
          </UitkFigure>
        </UitkCardMedia>
        <AlternateDestinationLink id={destination.id} linkName={destination.title} position={position} searchUrl={destination.searchUrl} />
      </UitkCard>
    );
  }
}
